import config from '@/config'
import { availableLanguages } from '@/lang/availableLang'
import auditStatus from '@/constants/auditStatus'

function getDefaultLang() {
  const defaultLanguage = availableLanguages.find(
    language =>
      language == window.navigator.language.replace('-', '_') ||
      window.navigator.language.includes(language.split('_')[0])
  )

  if (!defaultLanguage) return config.platformLang
  return defaultLanguage
}

export default {
  uuid: -1,
  userName: '',
  userId: '',
  eventEmailId: '',
  eventMobileId: null,
  individualUserName: '',
  userType: '',
  userTypeEnum: '',
  loginStatus: '',
  firstLoginToday: false,
  openAccountEnabled: false,
  countryCode: '',
  accessToken: '',
  url: '',
  lang: getDefaultLang(),
  accountAuditStatus: auditStatus.init,
  poiAuditStatus: auditStatus.init,
  poaAuditStatus: auditStatus.init,
  ibtPoiAuditStatus: auditStatus.init,
  ibtPoaAuditStatus: auditStatus.init,
  isChangedLangAtLandingPage: false,
  registerStep: 1,
  isDemo: false,
  tradingToolUrl: {},
  email: '',
  id3Pass: false,
  regulator: null,
  failedSecondTime: false,
  noDepositIsLogin: true,
  autoNotifyStatus: true,
  notificationVisible: false,
  emailMasked: '',
  salesCompany: '',
  fromPath: null,

  // security
  checkedAuthStatus: [], // 已验证过的
  authHeaders: {
    etxId: '',
    eCode: '',
    ptxId: '',
    pCode: '',
    tCode: '',
  },
  requiredAuths: {}, // 不同规则对应所需的验证方式
  loginCredentials: {},
  beforeLoginCountry: '', // 1201 1202 根据国家显示验证器提示语
  extras: {
    logoutStacktrace: false,
  },
  sessionId: null,
  sessionInternalId: null,
  hasVerify2FA: false,
  domain: {
    cpUrl: '',
    ibUrl: '',
    owUrl: '',
    backToMain: false
  }
}
